export { default } from './es/icons/RotateRightOutlined';